var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H26C27.1046 20 28 19.1046 28 18V2C28 0.89543 27.1046 0 26 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H26C27.1046 20 28 19.1046 28 18V2C28 0.89543 27.1046 0 26 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V20H28V0Z",
    fill: "#FF2936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0H0V20H10.6667V0Z",
    fill: "#128415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 13.3337C12.5075 13.3337 13.9999 11.8413 13.9999 10.0003C13.9999 8.15938 12.5075 6.66699 10.6666 6.66699C8.82564 6.66699 7.33325 8.15938 7.33325 10.0003C7.33325 11.8413 8.82564 13.3337 10.6666 13.3337Z",
    stroke: "#FAF94F",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 8.34104C9.33325 8.15269 9.47662 8 9.66024 8H11.6729C11.8535 8 11.9999 8.15192 11.9999 8.34104V10.6681C11.9999 11.4037 11.4081 12 10.6666 12C9.93021 12 9.33325 11.4098 9.33325 10.6681V8.34104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 10.667C11.0349 10.667 11.3333 9.70185 11.3333 9.33366C11.3333 8.96547 11.0349 8.66699 10.6667 8.66699C10.2985 8.66699 10 8.96547 10 9.33366C10 9.70185 10.2985 10.667 10.6667 10.667Z",
    fill: "#1D50B5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt1);
export default __webpack_public_path__ + "static/media/PT_1.2e20fa46.svg";
export { ForwardRef as ReactComponent };